module.exports = __webpack_public_path__ + "img/buy_normal_cn.4ea13a54.png";